/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddParkingRequestApiFrom } from '../../models/add-parking-request-api-from';
import { ParkingApiFrom } from '../../models/parking-api-from';

export interface ApiV3ServiceAddParkingPost$Plain$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AddParkingRequestApiFrom
}

export function apiV3ServiceAddParkingPost$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceAddParkingPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceAddParkingPost$Plain.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ParkingApiFrom>;
    })
  );
}

apiV3ServiceAddParkingPost$Plain.PATH = '/api/v3/service/AddParking';
